import { GeneralModel } from "./general.model";

export class HolidayModel extends GeneralModel {
    date: any;
}